import React, { useState } from "react";
import { Rings } from 'react-loader-spinner';
import loader from '../assets/svg/loader.svg';
import inmatelogo from '../assets/svg/inmate-logo.svg'
import "../css/Loader.css"

const useFullPageLoader = () => {
  const [loading, setLoading] = useState(false);

  return [
    loading ? (
      <div className="loader-container d-flex justify-content-center align-items-center">
        <div>
          {/* Loader Background */}
          <div className="col-bg"></div>
          {/* Main Loader */}
          <div className="col-loader">
            <img src={loader} alt="Loading..." className="col-loader-03" />
            <img src={inmatelogo} alt="Inmate Logo" className="col-loader-image" />
          </div>

        </div>
      </div>
      //     <div className="loading-container position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ zIndex: 1050 }}>
      //     <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-40"></div> {/* Bootstrap 5 backdrop with opacity */}
      //     <Rings
      //         height="200"
      //         width="200"
      //         color="#c8605e"
      //         radius="6"
      //         visible={true}
      //         ariaLabel="rings-loading"
      //     />
      // </div>
    ) : null,
    () => setLoading(true), // Show loader
    () => setLoading(false) // Hide loader
  ];
};

export default useFullPageLoader;
